import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-classic-2, click" maskId="round-filled-radius-1-stroke-1.5-IconMouseClassic2"><path d="M19 15C19 18.8659 15.866 22 12 22C8.13404 22 5.00005 18.8659 5 15V10.5H19V15Z" fill="currentColor"/><path d="M11.25 9H5V3.75C5.00001 2.78351 5.78351 2 6.75 2H11.25V9Z" fill="currentColor"/><path d="M17.25 2C18.2164 2.00001 18.9999 2.78358 19 3.75V9H12.75V2H17.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic2;
